module.exports = __webpack_public_path__ + "static/media/cloud3.162ea38c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Clouds/cloud3.svg
// module id = 530
// module chunks = 0